let language = {
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TITLE": "交易",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-EMPTY-TIPS": "订单是空的",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-ORDER": "订单编号",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-DATE": "订单日期",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-METHOD": "支付方式",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-TOTAL-PRICE": "总价格",

    "PAYMENTS-DASHBOARD-INVOICES-TITLE": "发票",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-NAME": "名称",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-PERIOD": "时间",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-REGION": "国家 / 地区",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-STORE": "店铺",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-BUTTON-RESET": "重置",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-BUTTON-SEARCH": "搜索",
    "PAYMENTS-DASHBOARD-INVOICES-BUTTON-BULK-DOWNLOAD": "批量下载发票",
    "PAYMENTS-DASHBOARD-INVOICES-ORDER-EMPTY-TIPS": "订单是空的",
    "PAYMENTS-DASHBOARD-INVOICES-ORDER-EMPTY-ELIGIBLE-TIPS": "没有符合条件的订单，请尝试其他搜索条件",

    // TABLE
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-NAME": "名称",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-REGION": "国家 / 地区",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-ORDER": "订单",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-AMOUNT": "数量",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-CREATED": "创建时间",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-PDF": "PDF",
    
};

export { language }